import React, { useState, useEffect } from 'react'

const LoadingOpaqueSpinner = () => {
    const [message, setMessage] = useState('Your request is being processed. Please wait')

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setMessage('Oh! Your request is late. Please wait')
    //     }, 3000)

    //     return () => clearTimeout(timer)
    // }, [])

    return (
        <>
            {/* Full-screen dark overlay */}
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 9999
            }} />

            {/* Centered animated text */}
            <div style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: 'white',
                fontSize: '28px',
                fontWeight: 'bold',
                zIndex: 10000
            }}>
                {message}
                {/* <span className="dot">.</span><span className="dot">.</span><span className="dot">.</span> */}
            </div>

            {/* CSS for animated dots */}
            <style>{`
        .dot {
          animation: blink 1.5s infinite;
        }

        .dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes blink {
          0%, 20% { opacity: 0 }
          50% { opacity: 1 }
          100% { opacity: 0 }
        }
      `}</style>
        </>
    )
}

export default LoadingOpaqueSpinner
